import { AdvisorUid } from 'components/features/coaching/advisor/types/advisor'
import {
  AdvisorMeetingWizardFields,
  FlowSpecificFields,
  AdvisorMeetingWizardRegularSpecificFields,
  AdvisorMeetingWizardProfileSpecificFields,
  AdvisorMeetingWizardLandingSpecificFields,
  AdvisorMeetingWizardNonRegularFields,
} from 'components/features/coaching/advisorMeeting/types/requests'
import { MeetingUid } from 'components/features/coaching/advisorPage/types/interfaces'
import { BaseFloatingPane } from 'interfaces/floatingPanes'


export const ADVISOR_FLOAT_PANE_TYPE = 'advisor' as const


export type TopicStepOutputFields = Pick<AdvisorMeetingWizardFields, 'topics' | 'notes'> & FlowSpecificFields

export type TopicStepInputFields =
  | AdvisorMeetingWizardRegularSpecificFields
  | AdvisorMeetingWizardProfileSpecificFields
  | (
    & Pick<AdvisorMeetingWizardLandingSpecificFields, 'flow'>
    & Partial<Omit<AdvisorMeetingWizardLandingSpecificFields, 'flow'>>
  )


type AdvisorRequestTopicPane = {
  mode: 'request'
  step: 'topic'
  fields: TopicStepInputFields
}

type AdvisorRequestSchedulePane = {
  mode: 'request'
  step: 'schedule'
  fields: TopicStepOutputFields
}

type AdvisorRequestSearchPane = {
  mode: 'request'
  step: 'search'
}

type AdvisorRequestBookingPane = {
  mode: 'request'
  step: 'booking' | 'confirm'
  fields: AdvisorMeetingWizardFields
}

type AdvisorSubscriptionPane = {
  mode: 'request'
  step: 'subscription'
  fields: AdvisorMeetingWizardFields
}

export type AdvisorSignupPane = {
  mode: 'request'
  step: 'signup'
  fields: AdvisorMeetingWizardNonRegularFields
}

type AdvisorRequestConfirmedPane = {
  mode: 'request'
  step: 'confirmed'
  uid: MeetingUid
  fields: AdvisorMeetingWizardFields
}

type AdvisorMeetingDetailsPane = {
  mode: 'meeting'
  uid: MeetingUid
}

type AdvisorDetailsPane = {
  mode: 'advisor'
  uid: AdvisorUid
}

export type AdvisorFloatPanesState =
  | AdvisorRequestTopicPane
  | AdvisorRequestSchedulePane
  | AdvisorRequestSearchPane
  | AdvisorRequestBookingPane
  | AdvisorSignupPane
  | AdvisorSubscriptionPane
  | AdvisorRequestConfirmedPane
  | AdvisorMeetingDetailsPane
  | AdvisorDetailsPane

export type AdvisorFloatPane =
  & BaseFloatingPane
  & {
    type: typeof ADVISOR_FLOAT_PANE_TYPE
  }
  & AdvisorFloatPanesState

export type AdvisorRequestStep = Extract<AdvisorFloatPane, { mode: 'request' }>['step']
